import { ApplicationState } from '../'
import * as actions from '@lynx/client-core/src/store/config/actions'
import { ThunkAction } from 'redux-thunk'
import { Action } from 'redux'
import { Config } from '@lynx/client-core/src/store/config'

type readConfig = (...args: Parameters<typeof actions.readConfig>) => ThunkAction<Promise<Config | null>, ApplicationState, null, Action<string>>
export const readConfig = actions.readConfig as unknown as readConfig
